import { supabase } from '../lib/supabase';

export const catalogCardService = {
  async getAll() {
    try {
      const { data, error } = await supabase
        .from('catalog_card_layouts')
        .select('*')
        .order('created_at', { ascending: false });

      if (error) throw error;
      return data || [];
    } catch (e) {
      console.error('catalogCardService.getAll error:', e);
      return [];
    }
  },

  async getPublished() {
    try {
      const { data, error } = await supabase
        .from('catalog_card_layouts')
        .select('*')
        .eq('is_published', true)
        .maybeSingle();

      if (error) throw error;
      return data;
    } catch (e) {
      console.error('catalogCardService.getPublished error:', e);
      return null;
    }
  },

  async create(layoutData) {
    try {
      const { data, error } = await supabase
        .from('catalog_card_layouts')
        .insert(layoutData)
        .select()
        .single();

      if (error) throw error;
      return data;
    } catch (e) {
      console.error('catalogCardService.create error:', e);
      throw e;
    }
  },

  async update(id, layoutData) {
    try {
      const { data, error } = await supabase
        .from('catalog_card_layouts')
        .update({
          ...layoutData,
          updated_at: new Date().toISOString()
        })
        .eq('id', id)
        .select()
        .single();

      if (error) throw error;
      return data;
    } catch (e) {
      console.error('catalogCardService.update error:', e);
      throw e;
    }
  },

  async delete(id) {
    try {
      const { error } = await supabase
        .from('catalog_card_layouts')
        .delete()
        .eq('id', id);

      if (error) throw error;
      return true;
    } catch (e) {
      console.error('catalogCardService.delete error:', e);
      throw e;
    }
  },
  
  async publish(id) {
     try {
        const { data, error } = await supabase
            .from('catalog_card_layouts')
            .update({ is_published: true, updated_at: new Date().toISOString() })
            .eq('id', id)
            .select()
            .single();
            
        if (error) throw error;
        return data;
     } catch (e) {
        console.error('catalogCardService.publish error:', e);
        throw e;
     }
  }
};
